// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as InfoClicker$LiveRoom from "../../components/InfoClicker.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as Tokens from "@sothebys/sterling/tokens";
import * as AuctionRoomSharedContacts$LiveRoom from "../../components/AuctionRoomSharedContacts.bs.js";

var container = Curry._1(Css.style, {
      hd: Css.width(Css.vw(30.0)),
      tl: {
        hd: Css.marginBottom(Css.px(16)),
        tl: {
          hd: Css.paddingLeft(Css.px(40)),
          tl: {
            hd: Css.paddingRight(Css.px(40)),
            tl: {
              hd: Css.media("(min-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"), {
                    hd: Css.minWidth(Css.px(400)),
                    tl: /* [] */0
                  }),
              tl: {
                hd: Css.media("(max-width:" + (StyleConstants$LiveRoom.mobileBreakpoint + ")"), {
                      hd: Css.height(Css.vh(100.0)),
                      tl: {
                        hd: Css.width(Css.vw(100.0)),
                        tl: {
                          hd: Css.paddingLeft(Css.px(20)),
                          tl: {
                            hd: Css.paddingRight(Css.px(20)),
                            tl: /* [] */0
                          }
                        }
                      }
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var textStyle = Curry._1(Css.style, {
      hd: Css.fontFamily({
            NAME: "custom",
            VAL: Tokens.FontFamily.mercuryDisplay
          }),
      tl: {
        hd: Css.fontSize(Css.px(16)),
        tl: {
          hd: Css.lineHeight({
                NAME: "em",
                VAL: 2.0
              }),
          tl: {
            hd: Css.textAlign("left"),
            tl: {
              hd: Css.whiteSpace("preWrap"),
              tl: /* [] */0
            }
          }
        }
      }
    });

var section = Curry._1(Css.style, {
      hd: Css.marginTop(Css.px(16)),
      tl: /* [] */0
    });

var enquiriesEmail = "enquiries@sothebys.com";

function ActionNeededToBid(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: React.createElement(PropSpread$LiveRoom.make, {
                    data: {
                      hd: {
                        TAG: /* TestId */1,
                        _0: "actionNeedToBid"
                      },
                      tl: /* [] */0
                    },
                    children: React.createElement("div", {
                          className: container
                        }, React.createElement(PropSpread$LiveRoom.make, {
                              data: {
                                hd: {
                                  TAG: /* TestId */1,
                                  _0: "actionNeedToBidText"
                                },
                                tl: /* [] */0
                              },
                              children: React.createElement("p", {
                                    className: textStyle
                                  }, Curry._1(t, "ActionNeededToBidBlock_actionNeededToBidText"))
                            }), React.createElement(PropSpread$LiveRoom.make, {
                              data: {
                                hd: {
                                  TAG: /* TestId */1,
                                  _0: "actionNeedToBidContactNumber"
                                },
                                tl: /* [] */0
                              },
                              children: React.createElement("div", {
                                    className: section
                                  }, React.createElement(InfoClicker$LiveRoom.make, {
                                        kind: /* Phone */1,
                                        title: Curry._1(t, "Common_us"),
                                        sub: AuctionRoomSharedContacts$LiveRoom.usNumber
                                      }), React.createElement(InfoClicker$LiveRoom.make, {
                                        kind: /* Phone */1,
                                        title: Curry._1(t, "Common_uk"),
                                        sub: AuctionRoomSharedContacts$LiveRoom.ukNumber
                                      }), React.createElement(InfoClicker$LiveRoom.make, {
                                        kind: /* Phone */1,
                                        title: Curry._1(t, "Common_hongKong"),
                                        sub: AuctionRoomSharedContacts$LiveRoom.hongKongNumber
                                      }), React.createElement(InfoClicker$LiveRoom.make, {
                                        kind: /* Phone */1,
                                        title: Curry._1(t, "Common_singapore"),
                                        sub: AuctionRoomSharedContacts$LiveRoom.singaporeNumber
                                      }))
                            }), React.createElement(PropSpread$LiveRoom.make, {
                              data: {
                                hd: {
                                  TAG: /* TestId */1,
                                  _0: "actionNeedToBidContactEmail"
                                },
                                tl: /* [] */0
                              },
                              children: JsxPPXReactSupport.createElementWithKey("email", InfoClicker$LiveRoom.make, {
                                    kind: /* Email */0,
                                    title: Curry._1(t, "ActionNeededToBid_email"),
                                    sub: enquiriesEmail
                                  })
                            }))
                  }),
              className: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                          hd: Css.important(Css.maxHeight(Css.pct(100))),
                          tl: {
                            hd: Css.important(Css.maxWidth(Css.pct(100))),
                            tl: /* [] */0
                          }
                        }),
                    tl: /* [] */0
                  }),
              onClose: props.onClose,
              isOpen: true,
              headerTitle: Curry._1(t, "Common_actionNeeded")
            });
}

var make = ActionNeededToBid;

export {
  container ,
  textStyle ,
  section ,
  enquiriesEmail ,
  make ,
}
/* container Not a pure module */
